<template>
  <v-layout column>
    <v-toolbar dense flat style="padding-left: 0; background: none">
      <v-toolbar-title class="pl-1 body-1">{{label}}</v-toolbar-title>
    </v-toolbar>

    <v-data-table
      class="dense"
      :headers="headers"
      :items="value"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <td>{{props.item.order}}</td>
        <td>{{props.item.name}}<br>{{props.item.appNo}}</td>
        <td>{{userTypeMap[props.item.personType]}}</td>
        <td>{{props.item.deptName}}</td>
        <td>{{stateMap[props.item.contactsType]}}</td>
        <td>{{props.item.contactsPhone}}<br>{{props.item.contactsEmail}}</td>
      </template>
    </v-data-table>
  </v-layout>
</template>
<script>
  import XUserSelect from '@/components/global/UserSelect'

  export default {
    name: 'appPerson',
    props: ['value', 'label', 'hint'],
    components: {XUserSelect},

    data() {
      return {
        headers: [
          {text: '排序', sortable: false, value: 'rank', width: 18},
          {text: '姓名，合同号/学号', align: 'left', sortable: false, value: 'name'},
          {text: '参与人类型', align: 'left', sortable: false, value: 'personType'},
          {text: '归属部门', align: 'left', sortable: false, value: 'deptName'},
          {text: '参与类别', align: 'left', sortable: false, value: 'contactsType'},
          {text: '手机/电子邮箱', align: 'left', sortable: false, value: 'contactsPhone'},
        ],
        stateMap: {
          lxr: "联系人",
          ptr: "普通申请人",
          fzr: "负责人"
        },
        userTypeMap: {
          yjs:"研究生",
          js:"教师",
          bks:"本科生",
          xw:"校外"
        },
        item: {
          dbid: null,
          intelId: null,
          userId: null,
          name: null,
          order: null,
          deptName: null,
          personType: null,
          appNo: null,
          contactsType: null,
          contactsPhone: null,
          contactsEmail: null
        }
      }
    }
  }
</script>
<style>
  div.menu__content.hide-list {
    display: none;
  }
</style>

